export interface RouteSettings {
  requireAuth: boolean // if true, requires login
}

export interface AccessSettings {
  routes: {
    [path: string]: RouteSettings
  }
}

export const DEFAULT_ROUTE_SETTINGS: { [path: string]: RouteSettings } = {
  '/chat': {
    requireAuth: true
  },
  '/chat/[id]': {
    requireAuth: true
  },
  '/api-playground': {
    requireAuth: true
  },
  '/docs': {
    requireAuth: false
  }
}

export const ROUTE_DISPLAY_NAMES: { [path: string]: string } = {
  '/docs': 'Documentation',
  '/chat': 'AI Chat',
  '/chat/[id]': 'Chat Conversation',
  '/api-playground': 'API Playground'
}
